<textarea #textArea id="input-textArea" pInputTextarea class="app-form" [(ngModel)]="value"
    (ngModelChange)="onModelChange()" [rows]="rows" [maxlength]="maxlength" [ngClass]="ngClass">
</textarea>